import apiClient from './client';
import { Invoice, PaginatedResponse, PaginationParams } from '../../shared/types';

interface InvoiceCreateData {
  name?: string;
  invoicerName?: string;
  invoicerAddress?: string;
  clientName?: string;
  clientAddress?: string;
  clientEIN?: string;
  timesheetUrl?: string;
  startDate?: string;
  endDate?: string;
  serviceDescription?: string;
  hours?: string;
  minutes?: string;
  serviceLines?: any;
  hourlyRate?: string;
  extraCosts?: any;
  rsuPercentage?: string;
  rsuBalanceBeforeTransfer?: string;
  message?: string;
  singleLineCostMode?: boolean;
  seasonalGraphic?: string | null;
}

export const invoiceApi = {
  /**
   * Get all invoices for the current user
   */
  async getAll(params?: PaginationParams): Promise<PaginatedResponse<Invoice>> {
    const response = await apiClient.get<{ invoices: Invoice[]; pagination: any }>('/invoices', {
      params,
    });
    return {
      data: response.data.invoices,
      pagination: response.data.pagination,
    };
  },

  /**
   * Get a single invoice by ID
   */
  async getById(id: number): Promise<Invoice> {
    const response = await apiClient.get<{ invoice: Invoice }>(`/invoices/${id}`);
    return response.data.invoice;
  },

  /**
   * Create a new invoice
   */
  async create(data: InvoiceCreateData): Promise<Invoice> {
    const response = await apiClient.post<{ invoice: Invoice }>('/invoices', data);
    return response.data.invoice;
  },

  /**
   * Update an existing invoice
   */
  async update(id: number, data: InvoiceCreateData): Promise<Invoice> {
    const response = await apiClient.put<{ invoice: Invoice }>(`/invoices/${id}`, data);
    return response.data.invoice;
  },

  /**
   * Duplicate an existing invoice into a new independent copy
   */
  async duplicate(id: number): Promise<Invoice> {
    const response = await apiClient.post<{ invoice: Invoice }>(`/invoices/${id}/duplicate`);
    return response.data.invoice;
  },

  /**
   * Delete an invoice
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/invoices/${id}`);
  },
};
